import React from 'react';
import { cn } from "@/lib/utils"
import './pulsating-button.css';

interface PulsatingButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}

export function PulsatingButton({ 
  children, 
  className,
  ...props 
}: PulsatingButtonProps) {
  return (
    <button
      className={cn(
        "pulsating-button",
        "bg-green-500 text-white rounded cursor-pointer border-none",
        "p-[min(10px,2vw)_min(20px,4vw)] text-[min(1.1rem,4vw)]",
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
} 